import React from "react";
import { toast } from "react-toastify";

const ToastContent = ({ title, errors }) => (
  <div>
    <p>{title}</p>
    <ul>
      {errors &&
        errors.map((error, index) => {
          return <li key={index}>{error.message}</li>;
        })}
    </ul>
  </div>
);

export const errorToast = body => {
  toast.error(<ToastContent title={body.message} errors={body.errors} />, {
    position: toast.POSITION.TOP_LEFT,
    autoClose: 5000
  });
};

export const errorNetworkToast = () => {
  toast.error(<ToastContent title="Brak połącznia do serwera!" />, {
    position: toast.POSITION.TOP_LEFT
  });
};

export const infoAddToast = () => {
  toast.info(<ToastContent title="Dodano pomyślnie" />, {
    position: toast.POSITION.TOP_LEFT
  });
};

export const infoEditToast = () => {
  toast.info(<ToastContent title="Edycja pomyślna" />, {
    position: toast.POSITION.TOP_LEFT
  });
};

export const infoDeleteToast = () => {
  toast.info(<ToastContent title="Usunięto pomyślnie" />, {
    position: toast.POSITION.TOP_LEFT
  });
};

export const infoEmailToast = (email) => {

  let message = `Link do zmiany Twojego hasła został Ci przesłany na adres: ${email}.`;

  toast.info(<ToastContent title={message} />, {
    position: toast.POSITION.TOP_LEFT
  });
};

export const infoResetPasswordToast = () => {

  let message = "Hasło zostało pomyślnie zmienione";

  toast.info(<ToastContent title={message} />, {
    position: toast.POSITION.TOP_LEFT
  });
};
